import { Component, Input, Output, EventEmitter, OnInit, OnChanges, SimpleChanges } from '@angular/core';

import * as Objects from '@core/objects';

import { ProjectLogbookEventList } from '@app/models/logbook-events.model';

@Component({
    selector: 'project-details-logbook-events-list',
    templateUrl: './events-list.component.html',
    styleUrls: ['./events-list.component.scss']
})
export class ProjectDetailsLogbookEventsListComponent implements OnInit, OnChanges{
	@Input() project: Objects.Request = null;
	@Input() events: Array<Objects.LogbookEvent> = null;
	@Input() searching: boolean;

    public eventsList: Array<Objects.LogbookEvent> = null;
    public activatedGroup: string = '';
    public eventList: Objects.EventTrack[] = ProjectLogbookEventList;
    protected allowedEventTypes: Array<string> = [];

    

    ngOnInit(): void {
        this.setAllowedEventTypes();
        if(this.events != null){
            this.updateEventList();
        }
    }

    ngOnChanges(changes: SimpleChanges): void {
        if(changes.events){
            this.updateEventList();
        }
    }

    onSelectGroup(group: string) : void {
        console.log("group to set/quit -->"+group);
        this.activatedGroup = (group == this.activatedGroup) ? '' : group;
    }

    isAllowedEvent(event: Objects.LogbookEvent) : boolean{
        return this.allowedEventTypes.some((type: string) => type == event.type);
    }

    //FILTER EVENTS by a custom list of events that we will not display not included eevnts (For instance priority)
    protected setAllowedEventTypes(){
        // this is used only to filter events by type to avoid unnecessary
        
        this.allowedEventTypes = this.eventList.map((et: Objects.EventTrack) => et.id);
        
    }

    updateEventList(){
        this.eventsList = this.events.filter((event: Objects.LogbookEvent) => this.allowedEventTypes.some((type: string) => type == event.type))
    }


}